import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(viewStyles, {
    ...viewStyles,
    headerLeftColumnGridItem: {
        width: [9, 9, 6, 6, 6],
        align: "top",
    },
    headerRightColumnGridItem: {
        width: [3, 3, 6, 6, 6],
        align: "top",
    },
});
